import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import NewsHomeContent from 'src/components/News/NewsHomeContent/NewsHomeContent'
import Footer from 'src/components/Footer/Footer'

const NewsHomePage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <NewsHomeContent />
      <Footer />
    </>
  )
}

export default NewsHomePage
